import SEOHead from '@/components/base/SEOHead';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturedCategories from './components/FeaturedCategories';
import LatestArticles from './components/LatestArticles';
import StatsSection from './components/StatsSection';
import CTASection from './components/CTASection';
import { siteInfo } from '@/mocks/siteInfo';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: '国产久久久 - 首页',
  description: siteInfo.description,
  url: siteInfo.url,
  inLanguage: 'zh-CN',
  isPartOf: {
    '@type': 'WebSite',
    name: siteInfo.name,
    url: siteInfo.url,
  },
  about: {
    '@type': 'Organization',
    name: siteInfo.name,
    url: siteInfo.url,
    description: siteInfo.description,
    email: siteInfo.email,
    telephone: siteInfo.phone,
    address: {
      '@type': 'PostalAddress',
      addressLocality: '北京',
      addressCountry: 'CN',
    },
  },
};

export default function HomePage() {
  return (
    <>
      <SEOHead
        title="国产久久久 - 首页"
        description={siteInfo.description}
        keywords="国产久久久,国产久久久精选,国产久久久最新,国产久久久合集,国产久久久高清,国产久久久在线,国产内容,精选内容,长效聚合,内容平台"
        ogType="website"
        schema={homeSchema}
      />
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <FeaturedCategories />
        <LatestArticles />
        <StatsSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}